<form #domainScriptSetupForm="ngForm" class="form-horizontal domain-script-guide" (ngSubmit)="submit()">
    <div class="mon-dialog-header">
        <page-header [header]="'Set up your domain' | translate" panelLeftClass="col-48 mt-2"></page-header>
    </div>
    <div class="mon-dialog-body-with-footer bg-body pt-3">
        <div class="card panel-monsido-card mx-4">
            <div class="card-body">
                <p translate>
                    You have now created your domain - the last step is to add the Acquia Web Governance tracking code to your website. <br>
                    The tracking code enables the show on page function and makes it possible for Acquia Web Governance to keep track of which pages on your domain are the most important.
                </p>

                <p class="mb-5 text-bold">
                    <span translate *ngIf="!cookieBannerModel.settings.enabled">
                        All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.
                    </span>
                    <span translate *ngIf="cookieBannerModel.settings.enabled">
                        Please add the script as close to the open HEAD-tag as possible
                    </span>
                </p>
                <mon-spinner [loading]="loading">
                    <div *ngIf="domain.settings.scripts && !loading">
                        <form-domain-script-guide-features-statistics (click)="setScriptUnsaved()">
                        </form-domain-script-guide-features-statistics>
                        <form-domain-script-guide-features-page-assist [domain]="domain"
                                                                       [pageAssistModel]="pageAssistModel"
                                                                       (click)="setScriptUnsaved()">
                        </form-domain-script-guide-features-page-assist>
                        <form-domain-script-guide-features-page-fix (click)="setScriptUnsaved()">
                        </form-domain-script-guide-features-page-fix>
                        <form-domain-script-guide-features-heatmaps (click)="setScriptUnsaved()">
                        </form-domain-script-guide-features-heatmaps>
                        <form-domain-script-guide-features-cookie-banner [domain]="domain"
                                                                         [cookieBannerModel]="cookieBannerModel"
                                                                         *ngIf="canUseCB || isDemo"
                                                                         (click)="setScriptUnsaved()">
                        </form-domain-script-guide-features-cookie-banner>
                        <div class="mon-script-wrapper">
                            <div *ngIf="pageAssistModel.settings.canSavePaSetting && !isDemo">
                                <mon-copy [target]="id"></mon-copy>
                            </div>
                            <div *ngIf="!pageAssistModel.settings.enabled && !isDemo">
                                <mon-copy [target]="id"></mon-copy>
                            </div>
                            <pre class="yellow demo-script"
                                 *ngIf="showScript"
                                 [id]="id"
                                 [ngClass]="{'can-not-copy': pageAssistModel.settings.enabled && !pageAssistModel.settings.canSavePaSetting}"
                                 [innerHTML]="getScript()">
                            </pre>
                        </div>
                    </div>
                </mon-spinner>
                <p class="text-bold">
                    <span>NOTE: If you want to copy the Legacy Script. Click </span><a role="button" (click)="openLegacy()">here</a>.
                </p>
            </div>
        </div>
    </div>

    <div class="mon-dialog-footer d-flex align-items-start">
         <div class="pl-4" *ngIf="formUnsaved">
                <span class="text-link fas fa-info-circle" aria-hidden="true"></span>
                <span translate>Don't forget to copy and update the script on your website!</span>
            </div>
        <button type="submit"
                data-test="save-button"
                class="btn btn-border-radius btn-secondary ml-auto"
                [disabled]="saveButtonDisabled"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: 'domain-script-guide-save'}">
            <span class="'fas fa-spinner fa-spin fa-fw'" *ngIf="saving" aria-hidden="true"></span>
            <span translate>Save</span>
        </button>
    </div>
</form>
